import { LINKEDJSON } from "./constants/specialContentTypes";

const getOffersList = ({ page, ...restData }) => ({
  method: "GET",
  url: "/offers",
  data: { ...restData, page: page + 1 },
});

const addOffer = (data) => ({
  method: "POST",
  url: "/offers",
  data,
  headers: { ...LINKEDJSON },
});

const createSalesInvoice = ({ id }) => ({
  method: "GET",
  url: `/offers/${id}/createsalesinvoice`,
});

const acceptOffer = ({ id }) => ({
  method: "GET",
  url: `/offers/${id}/accept`,
});

const updateOffer = ({ id, ...data }) => ({
  method: "PUT",
  url: `/offers/${id}`,
  data,
  headers: { ...LINKEDJSON },
});

const updateOfferDocument = ({ id, ...data }) => ({
  method: "PUT",
  url: `/offer_documents/${id}`,
  data,
  headers: { ...LINKEDJSON },
});

const deleteOffer = ({ id }) => ({
  method: "DELETE",
  url: `/offers/${id}`,
});

const downloadOffer = ({ docxUrl, id }) => ({
  method: "GET",
  url: docxUrl,
  options: { responseType: "blob" },
});

const exportOffer = ({ id }) => ({
  method: "GET",
  url:  `/offers/export/${id}`,
  options: { responseType: "blob" },
});

export const offersApi = {
  getOffersList,
  downloadOffer,
  exportOffer,
  addOffer,
  updateOffer,
  updateOfferDocument,
  deleteOffer,
  createSalesInvoice,
  acceptOffer,
};
